import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Enum } from '../config';
import { BizDatatableComponent } from '../biz-datatable/biz-datatable.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ServiceLocator } from '../../Services/locator.service';
import { BaseService } from '../../Services/base.service';

@Component({
    selector: 'employee-lookup',
    templateUrl: 'employee-lookup.component.html',
})
export class EmployeeLookupComponent implements OnInit, AfterViewInit {
    @Input() defaultValues: any[] = [];
    @Input() rows: any[] = [];
    @Input() headerHeight: number = 30;
    @Input() returnObject: any = {};
    @Input() scrollbarH: boolean = true;
    @Input() footerHeight: number = 50;
    @Input() limit: number = 10;
    @Input() hideEdit: boolean = true;
    @Input() hideView: boolean = false;
    @Input() hideDelete: boolean = true;
    @Input() columnMode: string = Enum.ColumnMode.standard;
    @Input() pagination: boolean = true;
    @Input() caption: string = "Leather";
    @Input() rowIndex: any;
    itemOptionsOrders: any;
    itemOrder: any;
    buttonDisabled = false;
    buttonState = '';
    // @Input() type: number = 1;

    @Input() public selectedRows: any[] = [];

    @ViewChild('lookupModal') lookupModal: TemplateRef<any>;
    @ViewChild('table') table: BizDatatableComponent;

    public _columns: any[] = [];
    public _type: number = 4;
    modalRef: any;
    @Input()
    get columns(): any {

        return this._columns;
    }
    set columns(columns: any) {

        this._columns = columns;
    }
    @Input()
    get type(): any {
        return this._type;
    }
    set type(type: any) {
        this._type = type;
        if (type === 5 && this._columns.length > 0) {
            let selectCol = {
                prop: 'selected',
                name: '',
                sortable: false,
                canAutoResize: false,
                draggable: false,
                resizable: false,
                headerCheckboxable: true,
                checkboxable: true,
                width: 50
            };
            this._columns.splice(0, 0, selectCol);
        }
    }

    private baseService: any;

    constructor(private modalService: BsModalService) {
        this.baseService = ServiceLocator.injector.get(BaseService);
    }

    @Output()
    onClick: EventEmitter<any> = new EventEmitter<any>();

    articlelist: any[] = [];
    head: any[] = [];
    articleParams: any[] = [];

    async getEmployee(filed, value) {
        let val = 'tType=1' + '&flocation=' + localStorage.getItem('LocationID') + '&USerID=' + localStorage.getItem('UserID') + '&filed=' + filed + '&value=' + value;
        await this.baseService.get('Employee', 'getEmployee', val).then(o => {
            if (o && o.length && o.length > 0) {
                this.rows = o;
            }
        })
    }

    async ngOnInit() { 
        this.itemOrder = { label: 'Name', value: 'fullName' };
        this.itemOptionsOrders = [
            { label: 'Employee ID', value: 'employeeID' },
            { label: 'Code', value: 'oldCardNo' },
            { label: 'Name', value: 'fullName' },
            { label: 'Department', value: 'department' },
            { label: 'Designation', value: 'designation' },
            { label: 'NIC #', value: 'nicno' },
        ];
    }

    async ngAfterViewInit() { }

    async open() {

        this.columns = [
            { prop: 'employeeID', name: 'Employee ID', width: 100 }, { prop: 'oldCardNo', name: 'Code', width: 100 },
            { prop: 'fullName', name: 'Name', width: 200 }, { prop: 'department', name: 'Department', width: 150 },
            { prop: 'designation', name: 'Designation', width: 150 }, { prop: 'nicno', name: 'NIC #', width: 150 }
        ];

        setTimeout(() => {
            this.caption = this.caption && this.caption !== "" ? this.caption : 'Lookup'
            this.modalRef = this.modalService.show(this.lookupModal, {
                animated: true,
                backdrop: 'static',
                class: 'modal-lg',
            });

        }, 0);

    }

    @Input()
    public LookupId: String = "";

    Click(row) {

        let obj = {
            grid: this.table,
            row: row,
            data: this.rows
        }

        if (obj) {

            if (this.modalRef)
                this.modalRef.hide()
            this.onClick.emit(obj);
        }
    }

    onSelection(selection) {

        if (selection) {

        }
    }

    save() {

        if (this.selectedRows) {

            this.modalRef.hide();
            return this.selectedRows;

        }
    }

    itemsPerPageChange(e) {

    }
    tempData: any[] = []
    async searchByButton(obj) {

        if (obj && obj.value) {
            await this.getEmployee(obj.item.value, obj.value)
        }

    }

    searchKeyUp(obj): void {

        const val = obj.event.target.value;

        if (val === "" && this.tempData.length > 0) {

            this.rows = [...this.tempData]
            this.tempData = [];
        }

        if (this.tempData.length === 0) this.tempData = this.rows;

        this.rows = this.rows.filter(i => i[obj.item.value].toString().toLowerCase().indexOf(val.toString().toLowerCase()) !== - 1);

    };
}

export interface LookupResult {
    lookupId: string;
    data: any;
}
